module.exports = __webpack_public_path__ + "static/media/thl.7a2d49b7.png";